import apiPrd from '../../services/apiPrd'

const DriverService = {
  async fetchDrivers(params) {
    const res = await apiPrd.post('/driver/search', params)
    return res.data
  },
  async rateDriver(id, params) {
    const res = await apiPrd.post(`/driver/${id}/evaluate`, params)
    return res.data
  },
  async searchDriverByCpf(cpf) {
    const res = await apiPrd.get(`/driver/searchDriverByCpf?cpf=${cpf}`)
    return res.data
  },
  async updateDriverByDataCiot(id, payload) {
    const res = await apiPrd.post(`/driver/${id}/updateDriverByDataCiot`, payload)
    return res
  },
}

export default DriverService
